var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlignCenterAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49984 0.5C1.0396 0.5 0.666504 0.873096 0.666504 1.33333C0.666504 1.79357 1.0396 2.16667 1.49984 2.16667H16.4998C16.9601 2.16667 17.3332 1.79357 17.3332 1.33333C17.3332 0.873096 16.9601 0.5 16.4998 0.5H1.49984Z",
    fill: "#BFBBCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 5.5C3.99984 5.03976 4.37293 4.66667 4.83317 4.66667H13.1665C13.6267 4.66667 13.9998 5.03976 13.9998 5.5C13.9998 5.96024 13.6267 6.33333 13.1665 6.33333H4.83317C4.37293 6.33333 3.99984 5.96024 3.99984 5.5Z",
    fill: "#BFBBCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49984 8.83333C1.0396 8.83333 0.666504 9.20643 0.666504 9.66667C0.666504 10.1269 1.0396 10.5 1.49984 10.5H16.4998C16.9601 10.5 17.3332 10.1269 17.3332 9.66667C17.3332 9.20643 16.9601 8.83333 16.4998 8.83333H1.49984Z",
    fill: "#BFBBCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83317 13C4.37293 13 3.99984 13.3731 3.99984 13.8333C3.99984 14.2936 4.37293 14.6667 4.83317 14.6667H13.1665C13.6267 14.6667 13.9998 14.2936 13.9998 13.8333C13.9998 13.3731 13.6267 13 13.1665 13H4.83317Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignCenterAlt);
export default __webpack_public_path__ + "static/media/icon-align-center-alt.9b4ffba67ee580a420b9b8da895e1b2b.svg";
export { ForwardRef as ReactComponent };